<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <input-select :selectTitle="'缴费状态'" style="margin-right: 10px;" :selectData="payStatusList" @search="search" :selectKey="'payStatus'" />
      <!--<div style="display: flex;justify-content: space-between">-->
        <!--<input-select selectTitle="缴费方式" :selectKey="'payWay'" :selectData="payWayList" @search="search"/>-->
      <!--</div>-->
      <input-search placeholder="预约人姓名" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @goToModifyPage="toModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/SiteReservation";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "site-bill",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧预约",
          name: "pay-record"
        },
        {
          value: "缴费记录"
        }
      ],
      exportUrl: "",
      payStatusList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "0",
          label: "未缴费"
        },
        {
          key: "1",
          label: "已缴费"
        }
      ],
      tableHead: [
        {
          prop: "personName",
          label: "预约人姓名"
        },
        {
          prop: "placeName",
          label: "场地名称"
        },
        {
          prop: "createTime",
          label: "创建时间"
        },
        {
          prop: "payAmount",
          label: "金额(元)"
        },
        {
          prop: "payStatusText",
          label: "缴费状态"
        }
      ],
      tableData: [],
      operationArr: ["modify"],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: "",
        payStatus: ""
      }
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportPlaceBooking}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&payStatus=${this.requestData.payStatus}`;
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getBillPage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              if (v.createTime) {
                v.createTime = v.createTime.slice(0, 19);
              }
              if (v.payStatus === "0") {
                v.payStatusText = "未缴费";
              } else if (v.payStatus === "1") {
                v.payStatusText = "已缴费";
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取缴费信息失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    toModifyPage(code) {
      this.$router.push({
        path: `/site_reservation/site_bill_modify/${code}`
      });
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/SiteReservation/SiteBill/SiteBill.vue